import { render, staticRenderFns } from "./CrudCreate.vue?vue&type=template&id=018270b6&"
import script from "./CrudCreate.vue?vue&type=script&lang=js&"
export * from "./CrudCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports